import { Button, Form, Input, Modal } from 'antd';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import MyUtil from '../../functions/MyUtil';
import '../css/About.css';
import '../css/AddVehicle.css';
import '../css/EditVehicle.css';

export default class ModalWday extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      weekdays: [],
      wdays: '',
    };
  }

  async componentDidMount() {
    var weekdays = await PartnerApi.getAllWdays();
    var wdays = this.props.wdays ? this.props.wdays : '';
    weekdays = weekdays ? weekdays : [];

    var arr = [];
    weekdays.forEach((element) => {
      var check = wdays.indexOf(element.wday_name) !== -1;
      element = Object.assign(element, {
        checked: check,
        [element['wday_name'] + '_note']: '',
      });
      arr.push(element);
    });

    arr.reverse();

    if (wdays != '' && wdays != null) {
      arr = MyUtil.convertManyOption(wdays);
    }
    var arrweekdays = [];
    weekdays.forEach((element, index) => {
      var check = wdays.indexOf(element.wday_name) !== -1;
      var note = arr[element['wday_name']];
      if (wdays)
        element = Object.assign(element, {
          checked: check,
          [element['wday_name'] + '_note']: note,
        });
      arrweekdays.push(element);
    });

    this.setState({ weekdays: arrweekdays });
  }

  handleChange = (event) => {
    var note = event.target.value;
    var weekdays = this.state.weekdays;
    if (weekdays) {
      weekdays.forEach((item, index) => {
        if (item.wday_name + '_note' == event.target.name) {
          weekdays[index][event.target.name] = MyUtil.convertMoney(note);
        }
      });
    }
    this.setState({ weekdays });
  };

  handleSelectOption = (event) => {
    var weekdays = this.state.weekdays;
    if (weekdays) {
      weekdays.forEach((item, index) => {
        if (item.wday_name == event.target.name) {
          weekdays[index].checked = event.target.checked;
          return;
        }
      });
      this.setState({ weekdays });
    }
  };

  handleSave = () => {
    var weekdays = this.state.weekdays;
    var wdays = '';
    weekdays.forEach((item) => {
      if (item.checked) {
        var note = item[item.wday_name + '_note'];
        if (note && note != '' && note.toString().trim() != '')
          wdays += item.wday_name + ':' + note + ',';
        else wdays += item.wday_name + ',';
      }
    });
    if (wdays && wdays.trim() != '') {
      wdays = wdays.substr(0, wdays.length - 1);
    }
    this.props.onChangeManyOption('wdays', wdays);
    this.setState({
      modal: false,
    });
  };

  handleCancel = () => {
    this.setState({
      modal: false,
    });
  };

  render() {
    const { weekdays, modal } = this.state;

    return (
      <>
        <Form.Item name={['wdays']} label="Giá cuối tuần">
          <Input />
        </Form.Item>

        <Button
          onClick={() => {
            this.setState({
              modal: true,
            });
          }}
        >
          Thêm/Thay đổi
        </Button>

        <Modal
          visible={modal}
          title="Thêm thủ tục đối tác"
          onOk={this.handleSave}
          onCancel={this.handleCancel}
        >
          <Row className="row-form">
            {Object.keys(weekdays).map((key) => {
              return (
                <div
                  key={key}
                  style={{ marginLeft: '20px' }}
                  className="policy-partner"
                >
                  <input
                    name={weekdays[key].wday_name}
                    type="checkbox"
                    defaultChecked={weekdays[key]['checked']}
                    onChange={this.handleSelectOption}
                  />
                  <div
                    className="lable-option"
                    style={{ width: '180px', display: '-webkit-inline-box' }}
                  >
                    {weekdays[key].wday_name}
                  </div>

                  <input
                    disabled={!weekdays[key]['checked']}
                    name={weekdays[key].wday_name + '_note'}
                    placeholder="% hoặc số tiền"
                    onChange={this.handleChange}
                    className="input-normal"
                    style={{ width: '253px' }}
                    value={
                      weekdays[key][weekdays[key].wday_name + '_note'] > 1000
                        ? MyUtil.currencyFormat(
                            weekdays[key][weekdays[key].wday_name + '_note']
                          )
                        : weekdays[key][weekdays[key].wday_name + '_note']
                    }
                  ></input>
                </div>
              );
            })}
          </Row>
        </Modal>
      </>
    );
  }
}
